import React from 'react';
import { Outlet } from 'react-router-dom';

const AuthPage = () => {
	return (
		<main>
			<Outlet />
		</main>
	);
};

export default AuthPage;
